const load_ready = setInterval(() => {
	new $$('body').each(item => {
		if(item.classList.contains('swym-ready')) {
			//start section homepage-hero

			// slider in block left
			const sliderLeftSwiper = new Swiper(".slider-left-swiper", {
				spaceBetween: 20,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				speed: 800,
				autoplay: {
					disableOnInteraction: false,
					delay: 3000,
				},
				addSlidesAfter: 2,
				addSlidesBefore: 2,
				loop: true,
			});

			//  slider in block right
			const sliderRightSwiper = new Swiper(".slider-right-swiper", {
				// spaceBetween: 20,
				pagination: {
					el: ".swiper-pagination",
					clickable: true,
				},
				speed: 800,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
				addSlidesAfter: 2,
				addSlidesBefore: 2,
				loop: true,
			});

			// finish section homepage-hero --- start section featured categories
			const featured_category = setTimeout(() => {
				const header_elements = new $$(".featured_categories .header_item");
				const categories_elements = new $$('.featured_categories .element_item');
				
				header_elements.on('click', (elem) => {
					remove_active(header_elements);
					elem.classList.add('active');
					hidden_elements(categories_elements);
					show_categories_elements(categories_elements);
				})
				
				show_header_items(header_elements);
				
				function show_header_items(header_items) {
					const obj = {};
					
					header_items.each((elem, index) => {
						if (obj[`${elem.dataset.item}`]) {
							return elem.remove();
						} else {
							if(index === 0) {
								elem.classList.add('active');
								new $$('.featured_categories .element_item').each(item => {
									item.dataset.item === elem.dataset.item && item.classList.remove('hidden');
								})
							}
							elem.classList.remove('hidden');
							return obj[`${elem.dataset.item}`] = elem.dataset.item;
						}
					});
				}
				
				function remove_active(elements) {
					elements.each(item => {
						item.classList.remove('active');
					})
				}
				
				function show_categories_elements(elements) {
					elements.each(categories_item => {
						new $$(".featured_categories .header_item").each(header_item => {
							if(header_item.classList.contains('active')) {
								if(header_item.dataset.item === categories_item.dataset.item) {
									categories_item.classList.remove('hidden');
								}
							}
						})
					})
				}
				
				function hidden_elements(elements) {
					elements.each(item => {
						item.classList.add('hidden')
					})
				}
				
				clearTimeout(featured_category)
			}, 2000)
			



			// finish section featured categories --- start section favorite_author

			
			const section_author = setTimeout(() => {
				const section_ready = new $$('.swym-ready .filter-container').self;
				
				if(section_ready) {
					const author_swiper = new Swiper('.favorites_author .author_slider', {
						init: true,
						slidesPerView: 1.608,
						spaceBetween: 11,
						navigation: {
							nextEl: ".swiper-button-next",
							prevEl: ".swiper-button-prev",
						},
						breakpoints: {
							425: {
								slidesPerView: 1.7,
							},
							500: {
								slidesPerView: 2.2,
							},
							650: {
								slidesPerView: 2.8,
							},
							768: {
								slidesPerView: 3
							},
							900: {
								slidesPerView: 4
							}
						}
					});
					
					const author_btns = new $$('.favorites_author .author_btn');
					const author_imgs = new $$('.favorites_author .box_image');
					const author_titles = new $$('.favorites_author .text .title');
					const author_links = new $$('.favorites_author .text .link');
					const autthor_slides = new $$('.favorites_author .author_slider .swiper-slide');
					
					hidden_show_slides(autthor_slides);
					
					author_btns.on('click', (btn, index) => {
						// hidden elements
						hidden_elements(author_btns);
						hidden_elements(author_imgs);
						hidden_elements(author_titles);
						hidden_elements(author_links);
						
						// show elements
						show_element(author_btns, index);
						show_element(author_imgs, index);
						show_element(author_titles, index);
						show_element(author_links, index);
						
						// show_hiden slides
						hidden_show_slides(autthor_slides, index)
					})
					
					function hidden_elements(elements) {
						elements.each(element => {
							element.classList.remove('active');
						})
					}
					
					function show_element(author_btn, index) {
						author_btn.elems[index].classList.add('active');
					}
					
					function hidden_show_slides(slides, selected_index = 0) {
						let selected = [];
						
						slides.each(slide => {
							selected.push(slide.dataset.type)
						})
						
						const filtered_slides = [...new Set(selected)];
						
						slides.each(slide => {
							
							if(slide.dataset.type === filtered_slides[selected_index] ) {
								slide.classList.remove('slide_hidden');
								slide.classList.add('swiper-slide');
								
							} else {
								slide.classList.add('slide_hidden');
								slide.classList.remove('swiper-slide');
							}
							
							const author_swiper = new Swiper('.favorites_author .author_slider', {
								init: true,
								slidesPerView: 1.608,
								spaceBetween: 11,
								navigation: {
									nextEl: ".swiper-button-next",
									prevEl: ".swiper-button-prev",
								},
								breakpoints: {
									425: {
										slidesPerView: 1.7,
									},
									500: {
										slidesPerView: 2.2,
									},
									650: {
										slidesPerView: 2.8,
									},
									768: {
										slidesPerView: 3
									},
									900: {
										slidesPerView: 4
									}
								}
							});
							
							
							// new $$('.favorites_author .author_slider').self.classList.add('swiper-initialized');
							new $$('.favorites_author .swiper-wrapper').self.style = 'transform: translate3d(0px, 0px, 0px);';
							author_swiper.realIndex = 0;
						})
					}
					
					clearInterval(section_author);
				}
			}, 2000)
			
			window.tude = window.tude || { cmd: [] };
			tude.cmd.push(function() {
				tude.refreshAdsViaDivMappings([
					{
						divId: 'my-leaderboard-1_4',
						baseDivId: 'div-gpt-ad-leaderboard-10',
					}
				]);
			});
			
			window.tude = window.tude || { cmd: [] };
			tude.cmd.push(function() {
				tude.refreshAdsViaDivMappings([
					{
						divId: 'my-leaderboard-2_4',
						baseDivId: 'div-gpt-ad-medium-1',
					}
				]);
			});
			
			clearInterval(load_ready);
		}
	})
}, 5)

